import axios from "axios";

const { REACT_APP_AUTH_API } = process.env;

export const getDrivers: any = (
  company,
  query,
  page = 1,
  cancelToken,
  orderBy = "first_name",
  order = "asc",
  filterBy = "",
) => {
  const url = `q=${query}&results_per_page=60&page=${page}&order_by=${orderBy}&order=${order}`;
  const params = new URLSearchParams(url);
  if (filterBy) {
    params.set("filters", filterBy);
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${company}/drivers?${params.toString()}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    cancelToken,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const getDriver: any = (company, driverId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${company}/drivers/${driverId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      const { data } = response.data;
      return data;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const addDriver: any = (company, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "post",
    url: `${REACT_APP_AUTH_API}/${company}/drivers`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  })
    .then((response) => {
      return { data: response };
    })
    .catch((e) => {
      return { detail: e.response.data.errors };
    });
};

export const editDriver: any = (company, driver, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "put",
    url: `${REACT_APP_AUTH_API}/${company}/drivers/${driver}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  })
    .then((response) => {
      return { data: response };
    })
    .catch((e) => {
      return { detail: e.response.data.errors };
    });
};

export const deleteDriver: any = (company, driverId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "delete",
    url: `${REACT_APP_AUTH_API}/${company}/drivers/${driverId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((error) => {
      return error?.response?.data?.details;
    });
};

export const downloadDrivers = async (
  customerId: string,
  driverIds: string,
  query: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  const response = await axios({
    method: "get",
    url: `${REACT_APP_AUTH_API}/${customerId}/drivers/download?drivers_ids_in=${driverIds}&q=${query}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data?.data;
};

export const deleteDrivers = async (
  customerId: string,
  driverIds: string,
  query: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const params = new URLSearchParams();
  if (driverIds && driverIds !== "all") {
    params.set("driver_ids_in", driverIds);
  } else if (query && driverIds && driverIds === "all") {
    params.set("q", query);
  }
  const response = await axios({
    method: "delete",
    url: `${REACT_APP_AUTH_API}/${customerId}/drivers?${params.toString()}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response?.data;
};

export const importDrivers = async (customerId: string, drivers: any) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_AUTH_API}/${customerId}/drivers/import`,
      headers: { Authorization: `Bearer ${token}` },
      data: drivers,
    });
    return response;
  } catch (e) {
    return { e };
  }
};
